import { render, staticRenderFns } from "./screen3.vue?vue&type=template&id=2060e977&scoped=true&"
import script from "./screen3.vue?vue&type=script&lang=js&"
export * from "./screen3.vue?vue&type=script&lang=js&"
import style0 from "./screen3.vue?vue&type=style&index=0&id=2060e977&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2060e977",
  null
  
)

export default component.exports